// Dutch defaults below are the fallback; Pimcore Shared Translations override
// per key via the mount payload. Placeholders use the Symfony %name% convention.

const defaults = {
  'listing-search.location.label': 'Waar wil je wonen?',
  'listing-search.location.placeholder': 'Plaats, regio of projectnaam',
  'listing-search.location.clear': 'Locatie wissen',
  'listing-search.location.anywhere': 'Overal',
  'listing-search.price.label': 'Budget',
  'listing-search.price.all': 'Alle prijzen',
  'listing-search.price.clear': 'Prijsrange wissen',
  'listing-search.price.between': 'Van %min% tot %max%',
  'listing-search.price.frequently-chosen': 'Veelgekozen',
  'listing-search.price.min': 'Min',
  'listing-search.price.max': 'Max',
  'listing-search.price.min-aria': 'Minimumprijs',
  'listing-search.price.max-aria': 'Maximumprijs',
  'listing-search.price.up-to': 'Tot %price%',
  'listing-search.price.from': 'Vanaf %price%',
  'listing-search.housing.label': 'Type & indeling',
  'listing-search.housing.all': 'Alle woningen',
  'listing-search.housing.clear': 'Type en indeling wissen',
  'listing-search.housing.types-count': '%count% woningtypes',
  'listing-search.housing.bedrooms-summary': '%beds% (slaap)kamers',
  'listing-search.housing.parcel-summary': '%range% m² perceel',
  'listing-search.housing.kind': 'Soort woning',
  'listing-search.housing.rooms': '(Slaap)kamers',
  'listing-search.housing.living-area': 'Wonen',
  'listing-search.housing.living-area-aria': 'Woonoppervlakte',
  'listing-search.housing.parcel-area': 'Perceeloppervlakte',
  'listing-search.skip': 'Sla over',
  'listing-search.submit': 'Zoeken',
  'listing-search.suggest.projects': 'Projecten',
  'listing-search.suggest.places': 'Plaatsen',
  'listing-search.suggest.popular': 'Populaire locaties',
  'listing-search.suggest.none': 'Geen locatie gevonden',
  'listing-search.suggest.loading': 'Zoeken…',
  'listing-search.suggest.radius': 'Zoekstraal vanaf middelpunt',
  'listing-map.radius-clear': 'Straal verwijderen',
  'listing-search.nearby.loading': 'Locatie ophalen…',
  'listing-search.nearby.unavailable': 'Locatie niet beschikbaar',
  'listing-search.clear': 'Wissen',
  'listing-search.type-select.all': 'Alle woningtypes',
  'listing-search.type-select.clear': 'Selectie wissen',
  'listing-search.sheet.title': 'Hoe wil je wonen?',
  'listing-search.sheet.close': 'Sluiten',
  'listing-search.sheet.clear-all': 'Alle filters wissen',
  'listing-search.sheet.aria-label': 'Zoekfilter',
  'listing-filter-bar.clear': 'Filters wissen',
  'listing-filter-bar.status.all': 'Status',
  'listing-filter-bar.status.count': '%count% statussen',
  'listing-filter-bar.status.available': 'Beschikbaar',
  'listing-filter-bar.status.option': 'In optie',
  'listing-filter-bar.sort.summary': 'Sorteren: %label%',
  'listing-filter-bar.sort.distance-asc': 'Afstand - dichtbij',
  'listing-filter-bar.sort.name-asc': 'Alfabetisch A-Z',
  'listing-filter-bar.sort.name-desc': 'Alfabetisch Z-A',
  'listing-filter-bar.sort.price-asc': 'Prijs laag-hoog',
  'listing-filter-bar.sort.price-desc': 'Prijs hoog-laag',
  'listing-filter-bar.sort.m2-asc': 'Oppervlakte klein-groot',
  'listing-filter-bar.sort.m2-desc': 'Oppervlakte groot-klein',
  'listing-filter-bar.sort.status': 'Status',
  'listing-toolbar.result-label': 'woning gevonden',
  'listing-toolbar.results-label': 'woningen gevonden',
  'listing-toolbar.map-filtered': 'Toont %shown% van de %total% woningen',
  'listing-toolbar.map-filtered-tooltip': 'Je ziet alleen de woningen binnen het zichtbare kaartgebied',
  'listing-toolbar.error': 'Er ging iets mis',
  'listing-toolbar.views-aria': 'Weergave kiezen',
  'listing-toolbar.view.list': 'Lijst',
  'listing-toolbar.view.both': 'Beide',
  'listing-toolbar.view.map': 'Kaart',
  'listing-card.type-designation': '%kind% - type %variant%',
  'listing-card.price-on-request': 'Prijzen nog niet bekend',
  'listing-card.price.suffix': 'v.o.n.',
  'listing-card.price.indicative-prefix': 'Vanaf indicatief',
  'listing-card.spec.living': 'Wonen',
  'listing-card.spec.layer': 'Woonlaag',
  'listing-card.spec.parcel': 'Perceel',
  'listing-card.spec.bedrooms': 'Slaapk.',
  'listing-card.spec.energy': 'Energielabel',
  'listing-card.image-prev': 'Vorige foto',
  'listing-card.image-next': 'Volgende foto',
  'listing-card.image-goto': 'Naar foto %index%',
  'listing-card.no-image': 'Geen foto beschikbaar',
  'listing-map.unavailable': 'Kaart kon niet geladen worden',
  'listing-map.legend.title': 'Legenda',
  'listing-map.legend.show': 'Legenda tonen',
  'listing-map.legend.hide': 'Legenda verbergen',
  'listing-map.popup.home': '1 woning',
  'listing-map.popup.homes': '%count% woningen',
  'listing-map.popup.bnr': 'Bnr %number%',
  'listing-map.popup.loading': 'Woningen laden…',
  'listing-map.popup.error': 'Woningen laden mislukt',
  'listing-map.popup.project-cta': 'Bekijk project',
  'listing-map.popup.close': 'Sluiten',
  'listing-map.card.prev': 'Vorige',
  'listing-map.card.next': 'Volgende',
  'listing-map.card.counter': '%index% van %total%',
  'listing-map.card.aria-label': 'Geselecteerde woning',
  'listing-map.fullscreen.enter': 'Kaart op volledig scherm',
  'listing-map.fullscreen.exit': 'Volledig scherm sluiten',
  'listing-map.legend.location': 'Woningen op deze locatie',
  'listing-map.legend.cluster': 'Meerdere projecten — zoom in',
  'listing-map.legend.upcoming': 'Toekomstig woningaanbod',
  'listing-map.cluster.summary': '%count% woningen in %projects% projecten',
  'listing-map.cluster.zoom': 'Klik om in te zoomen',
  'listing-map.pin.hint': 'Klik voor meer informatie',
  'listing-map.zoom-hint': 'Gebruik Ctrl + scrollen om de kaart te zoomen',
  'listing-map.zoom-hint-mac': 'Gebruik ⌘ + scrollen om de kaart te zoomen',
  'listing-map.zoom-hint-mobile': 'Gebruik twee vingers om de kaart te bewegen',
  'listing-results.empty.title': 'Geen woningen gevonden',
  'listing-results.empty.body': 'Pas je filters of landkaart weergave aan om meer resultaten te zien.',
  'projects-toolbar.result-label': 'project gevonden',
  'projects-toolbar.results-label': 'projecten gevonden',
  'projects-results.empty.title': 'Geen projecten gevonden',
  'projects-results.empty.body': 'Pas je filters of landkaart weergave aan om meer resultaten te zien.',
  'projects-filter-bar.regions.all': "Regio's",
  'projects-filter-bar.regions.count': "%count% regio's",
  'projects-filter-bar.sort.distance-asc': 'Afstand - dichtbij',
  'projects-filter-bar.sort.name-asc': 'Alfabetisch A-Z',
  'projects-filter-bar.sort.name-desc': 'Alfabetisch Z-A',
  'projects-filter-bar.sort.region-asc': 'Regio A-Z',
  'projects-filter-bar.sort.region-desc': 'Regio Z-A',
  'project-card.spec.home': '%count% woning',
  'project-card.spec.homes': '%count% woningen',
  'projects-map.cluster.summary': '%count% fases',
  'projects-map.popup.title': '%city%',
  'projects-map.popup.title-bare': 'Nieuwbouwprojecten',
  'projects-map.popup.project-one': '1 fase',
  'projects-map.legend.location': 'Fases op deze locatie',
  'projects-map.legend.cluster': 'Meerdere locaties — zoom in',
  'projects-map.card.aria-label': 'Geselecteerde fase',
  'projects-map.card.cta': 'Bekijk fase',
  'listing-detail.aria-label': 'Woningdetails',
  'listing-detail.close': 'Sluiten',
  'listing-detail.bnr': 'Bnr. %number%',
  'listing-detail.view-home': 'Bekijk woning',
  'listing-detail.view-project': 'Bekijk project',
  'listing-detail.specs.toggle': 'Bekijk alle specificaties',
  'listing-detail.specs.kind': 'Soort woning',
  'listing-detail.specs.living': 'Wonen',
  'listing-detail.specs.parcel': 'Perceel',
  'listing-detail.specs.energy': 'Energielabel',
  'listing-detail.specs.orientation': 'Oriëntatie tuin/balkon',
  'listing-detail.specs.bedrooms': 'Slaapkamers',
  'listing-detail.specs.layer': 'Woonlaag',
  'listing-detail.specs.garden-depth': 'Gemiddelde tuindiepte',
  'listing-detail.specs.outbuilding': 'Bijgebouwen',
  'listing-detail.specs.parking': 'Parkeergelegenheid',
  'listing-detail.specs.volume': 'Inhoud',
  'listing-detail.specs.kitchen-cheque': 'Keukencheque',
  'listing-detail.error': 'Woningdetails laden mislukt',
  'project-detail.aria-label': 'Projectdetails',
  'project-detail.follow-project': 'Volg project',
  'project-detail.specs.homes': 'Woningen',
  'project-detail.loading': 'Omschrijving laden…',
  'project-detail.error': 'Projectdetails laden mislukt'
};

let overrides = {};

export const setTranslations = (translations) => {
  overrides = translations || {};
};

export const t = (key, params = {}) => {
  let message = overrides[key] || defaults[key] || key;
  Object.entries(params).forEach(([name, value]) => {
    message = message.replace(`%${name}%`, String(value));
  });
  return message;
};

export const translationKeys = Object.keys(defaults);
